import React from "react";
import { Link } from "react-router-dom";

function DailySummaryReport() {
  return (
    <main>
      <div className="text-d-bg-text text-3xl text-center my-4">
        Daily Summary Report
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <div className="md:flex block flex-wrap  gap-5 ms-4 my-2 items-center ">
        <div>
          <label htmlFor="" className="w-full lg:w-1/3">
            <span className="text-d-bg-text text-sm mb ">Date</span>
            <div className="mb-2 pt-0">
              <input
                type="date"
                className="px-2 py-2  text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
              />
            </div>
          </label>
        </div>

        <Link
          className="bg-d-cat-btn text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 mt-3 w-fit"
          type="button"
        >
          Submit
        </Link>
        <Link
          className="bg-d-cat-btn text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 mt-3 w-fit ms-auto"
          type="button"
        >
          Print
        </Link>
      </div>
      <div>
        <h1 className="text-d-bg-text text-3xl text-center ">Imdady RMS</h1>
      </div>

      <div className="my-12">
        <div className="my-10">
          <h1 className="text-d-bg-text text-2xl text-center ">
            Daily Summary Report
          </h1>
          <p className="text-d-bg-text text-center">Date: 2024/01/24</p>
        </div>
        <table className="border-solid border-2 border-black w-full">
          <thead>
            <tr className="border-b-2 border-black ">
              <th className="py-3  border-r-2 border-black">SN</th>
              <th className="py-3 border-r-2 border-black">Reference No </th>
              <th className="py-3 border-r-2 border-black">Supplier</th>
              <th className="py-3 border-r-2 border-black">G. Total</th>
              <th className="py-3 border-r-2 border-black">Paid</th>
              <th className="py-3 border-r-2 border-black">Due</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black">Sum</td>
              <td className="py-1  border-r-2 border-black">0</td>
              <td className="py-1  border-r-2 border-black">0</td>
              <td className="py-1  border-r-2 border-black">0</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-12">
        <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
          Sale
        </h1>
        <table className="border-solid border-2 border-black w-full">
          <thead>
            <tr className="border-b-2 border-black ">
              <th className="py-3  border-r-2 border-black">SN</th>
              <th className="py-3 border-r-2 border-black">Reference No </th>
              <th className="py-3 border-r-2 border-black">Order Type</th>
              <th className="py-3 border-r-2 border-black">Table</th>
              <th className="py-3 border-r-2 border-black">Customer</th>
              <th className="py-3 border-r-2 border-black">Total Payable</th>
              <th className="py-3 border-r-2 border-black">Discount</th>
              <th className="py-3 border-r-2 border-black">Paid</th>
              <th className="py-3 border-r-2 border-black">Due</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center border-b-2 border-black">
              <td className="py-1  border-r-2 border-black">1</td>
              <td className="py-1  border-r-2 border-black">000367</td>
              <td className="py-1  border-r-2 border-black">Take Away </td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black">
                Walk-in Customer
              </td>
              <td className="py-1  border-r-2 border-black">20.00</td>
              <td className="py-1  border-r-2 border-black">0</td>
              <td className="py-1  border-r-2 border-black">20.00</td>
              <td className="py-1  border-r-2 border-black"></td>
            </tr>
            <tr className="text-center">
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black">Sum</td>
              <td className="py-1  border-r-2 border-black">20</td>
              <td className="py-1  border-r-2 border-black">0</td>
              <td className="py-1  border-r-2 border-black">20</td>
              <td className="py-1  border-r-2 border-black">0</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-12">
        <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
          Expenses
        </h1>
        <table className="border-solid border-2 border-black w-full">
          <thead>
            <tr className="border-b-2 border-black ">
              <th className="py-3  border-r-2 border-black">SN</th>
              <th className="py-3 border-r-2 border-black">Amount </th>
              <th className="py-3 border-r-2 border-black">Category</th>
              <th className="py-3 border-r-2 border-black">
                Responsible Person
              </th>
              <th className="py-3 border-r-2 border-black">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td className="py-1  border-r-2 border-black">Sum</td>
              <td className="py-1  border-r-2 border-black">0</td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-12">
        <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
          Supplier Due Payments
        </h1>
        <table className="border-solid border-2 border-black w-full">
          <thead>
            <tr className="border-b-2 border-black ">
              <th className="py-3  border-r-2 border-black">SN</th>
              <th className="py-3 border-r-2 border-black">Amount </th>
              <th className="py-3 border-r-2 border-black">Supplier</th>
              <th className="py-3 border-r-2 border-black">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td className="py-1  border-r-2 border-black">Sum</td>
              <td className="py-1  border-r-2 border-black">0</td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-12">
        <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
          Customer Due Receives
        </h1>

        <table className="border-solid border-2 border-black w-full">
          <thead>
            <tr className="border-b-2 border-black ">
              <th className="py-3  border-r-2 border-black">SN</th>
              <th className="py-3 border-r-2 border-black">Amount </th>
              <th className="py-3 border-r-2 border-black">Customer</th>
              <th className="py-3 border-r-2 border-black">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td className="py-1  border-r-2 border-black">Sum</td>
              <td className="py-1  border-r-2 border-black">0</td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="my-12">
        <h1 className="text-d-bg-text my-12 text-xl text-center font-semibold">
          Waste
        </h1>

        <table className="border-solid border-2 border-black w-full">
          <thead>
            <tr className="border-b-2 border-black ">
              <th className="py-3  border-r-2 border-black">SN</th>
              <th className="py-3 border-r-2 border-black">Reference No </th>
              <th className="py-3 border-r-2 border-black">Loss Amount</th>
              <th className="py-3 border-r-2 border-black">
                Responsible Person
              </th>
              <th className="py-3 border-r-2 border-black">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center">
              <td className="py-1  border-r-2 border-black">Sum</td>
              <td className="py-1  border-r-2 border-black">0</td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
              <td className="py-1  border-r-2 border-black"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  );
}

export default DailySummaryReport;
